import { render, staticRenderFns } from "./FoodItemView.vue?vue&type=template&id=03c51615&"
import script from "./FoodItemView.vue?vue&type=script&lang=js&"
export * from "./FoodItemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports